import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./PrivateRoute";

/* IMPORT ALL YOUR PAGES HERE */
import HomePageOne from "./pages/HomePageOne";

import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";

import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

import ViewProfilePage from "./pages/ViewProfilePage";

import BlogPage from "./pages/BlogPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import AddBlogPage from "./pages/AddBlogPage";
import { OutletsList } from "./pages/OutletsList";
import { AddOutlet } from "./pages/AddOutlet";
import { AddCategory } from "./pages/AddCategory";
import { CategoryListPage } from "./pages/CategoryListPage";
import { AddUnitPage } from "./pages/AddUnitPage";
import { UnitListPage } from "./pages/UnitListPage";
import { AddSupplierPage } from "./pages/AddSupplierPage";
import { SuppliersListPage } from "./pages/SupplierListPage";
import { WoodTypeListPage } from "./pages/WoodTypeListPage";
import { AddWoodTypePage } from "./pages/AddWoodType";
import { SubCategoryListPage } from "./pages/SubCategoryListPage";
import { AddSubCategoryPage } from "./pages/AddSubCategoryPage";
import { CalculateCFTPage } from "./pages/CalculateCFTPage";
import RawMaterialListPage from "./pages/RawMaterialListPage";
import AddRawMaterialPage from "./pages/AddRawMaterialPage";
import { NonInventoryItemListPage } from "./pages/NonInventoryItemListPage";
import { AddNonInventoryItemPage } from "./pages/AddNonInventoryItemPage";
import { AddPurchaseOrderPage } from "./pages/AddPurchaseOrderPage";
import { PurchaseOrderListPage } from "./pages/PurchaseOrderListPage";
import AddUserPage from "./pages/AddUserPage";
import { UserListPage } from "./pages/UserListPage";
import { AddRolePage } from "./pages/AddRolePage";
import { RoleListPage } from "./pages/RoleListPage";
import { ProductivityReportPage } from "./pages/ProductivityReportPage";
import UserReportPage from "./pages/UserReportPage";
import { TeamReportPage } from "./pages/TeamReportPage";
import { AddLeadPage } from "./pages/AddLeadPage";
import { LeadListPage } from "./pages/LeadListPage";
import { AddTeamPage } from "./pages/AddTeamPage";
import { TeamListPage } from "./pages/TeamListPage";
import { AssignLeadPage } from "./pages/AssignLeadPage";
import { AssignLeadListPage } from "./pages/AssignLeadListPage";
import { AddCampaignPage } from "./pages/AddCampaignPage";
import { CampaignListPage } from "./pages/CampaignListPage";
import { TeamsManagerListPage } from "./pages/TeamsManagerListPage";
import LeadStatusList from "./components/leads/LeadStatusList";
import ViewLead from "./components/leads/ViewLead";
import ViewCampaign from "./components/campaigns/ViewCampaign";
import ViewTeamLayer from "./components/teams/ViewTeamLayer";
import { AddPackageLayer } from "./components/package/AddPackageLayer";
import { AddPackagePage } from "./pages/AddPackagePage";
import { PackagePageList } from "./pages/PackagePageList";
import { TmReportDetailsPage } from "./pages/TmReportDetailsPage";
import { CategoryPage } from "./pages/CategoryPage";
import { AddSchoolPage } from "./pages/AddSchoolPage";
import { SchoolListPage } from "./pages/SchoolListPage";
import { StudentListPage } from "./pages/StudentListPage";
import MangerPage from "./pages/MangerPage";
import { CallReportPage } from "./pages/CallReportPage";
import { SchoolPage } from "./pages/SchoolPage";
import LeadReportPage from "./pages/leadReportPage";
import FollowupsReportPage from "./pages/FollowupsReportPage";
import ManagePackagePage from "./pages/ManagePackagePage";
import PaymentQrPage from "./pages/PaymentQrPage";
import { PaymentListPage } from "./pages/PaymentListPage";
import NotificationPage from "./pages/NotificationPage";
import FirmwareManagePage from "./pages/FirmwareManagePage";
import LoginImageManagePage from "./pages/LoginImageManagePage";
import AssignDevicePage from "./pages/AssignDevicePage";
import { OperatorPage } from "./pages/OperatorPage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route exact path="/privacy-policy" element={<PrivacyPolicyPage />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Routes>
                <Route exact path="/" element={<HomePageOne />} />
                <Route
                  exact
                  path="/view-profile"
                  element={<ViewProfilePage />}
                />

                {/* ROLES */}
                <Route path="/role-list" element={<RoleListPage />} />
                <Route path="/add-role" element={<AddRolePage />} />
                <Route path="/edit-role/:id" element={<AddRolePage />} />

                {/* USERS */}
                <Route path="/user-list" element={<UserListPage />} />
                <Route path="/add-user" element={<AddUserPage />} />
                <Route path="/add-user/:id" element={<AddUserPage />} />

                {/* TEAMS */}
                <Route path="/assign-list" element={<TeamListPage />} />
                <Route path="/teams-list" element={<TeamsManagerListPage />} />

                <Route path="/add-assign" element={<AddTeamPage />} />
                <Route path="/add-assign/:id" element={<AddTeamPage />} />
                <Route path="/view-team/:id" element={<ViewTeamLayer />} />

                <Route path="/categoryes" element={<CategoryPage />} />

                {/* LEADS */}
                <Route path="/lead-list" element={<LeadListPage />} />
                <Route path="/view-lead/:id" element={<ViewLead />} />
                <Route path="/add-lead" element={<AddLeadPage />} />

                <Route path="/add-lead/:id" element={<AddLeadPage />} />
                <Route path="/lead-status" element={<LeadStatusList />} />
                <Route
                  path="/assign-lead-list"
                  element={<AssignLeadListPage />}
                />

                <Route path="/add-campaign" element={<AddCampaignPage />} />
                <Route path="/add-campaign/:id" element={<AddCampaignPage />} />
                <Route path="/campaign-list" element={<CampaignListPage />} />
                <Route path="/view-campaign/:id" element={<ViewCampaign />} />

                {/* REPORTS */}
                <Route path="/reports-team" element={<TeamReportPage />} />
                <Route path="/call-report" element={<CallReportPage />} />
                <Route path="/user-report" element={<UserReportPage />} />
                <Route path="/lead-report" element={<LeadReportPage />} />
                <Route
                  path="/followups-report"
                  element={<FollowupsReportPage />}
                />
                <Route
                  path="/reports/productivity"
                  element={<ProductivityReportPage />}
                />
                <Route
                  path="/tm-report/:tmId"
                  element={<TmReportDetailsPage />}
                />

                <Route path="/add-package" element={<AddPackagePage />} />
                <Route path="/add-package/:id" element={<AddPackagePage />} />
                <Route path="/package-list" element={<PackagePageList />} />

                {/* SCHOOLS */}
                <Route path="/school-list" element={<SchoolListPage />} />
                <Route path="/student-list" element={<StudentListPage />} />
                <Route path="/add-school" element={<AddSchoolPage />} />
                <Route path="/edit-school/:id" element={<AddSchoolPage />} />

                <Route path="/school-management" element={<MangerPage />} />
                <Route path="/school-file" element={<SchoolPage />} />
                <Route path="/manage-package" element={<ManagePackagePage />} />
                <Route path="/payment-list" element={<PaymentListPage />} />
                <Route path="/payment-settings" element={<PaymentQrPage />} />
                <Route path="/notification" element={<NotificationPage />} />
                <Route path="/firmware-manage" element={<FirmwareManagePage />} />
                <Route path="/login-image-manage" element={<LoginImageManagePage />} />
                <Route path="/assign-devices" element={<AssignDevicePage />} />
                <Route path="/operator-files" element={<OperatorPage />} />

                <Route exact path="*" element={<ErrorPage />} />
              </Routes>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
